module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/QrMena/cashier/cashier-index-component/cashier-index-compomnent.css
// module id = ./src/QrMena/cashier/cashier-index-component/cashier-index-compomnent.css
// module chunks = main